import React from 'react';
import cn from 'classnames';

const Annotation = ({ id, name, onClick, disabled }) => (
  <li
    className="flex items-start px-6 py-4 transition-all duration-300 border-t border-neutral-200 border-solid cursor-pointer first:border-0 hover:bg-neutral-200"
    onClick={onClick}
  >
    <div
      className={cn(
        'w-4 h-4 mt-0.5 mr-2 rounded-md relative bg-purple-light border border-transparent border-solid',
        { 'bg-neutral-100 border border-neutral-300 border-solid': disabled }
      )}
    >
      <svg
        className={cn(
          'absolute inset-0 w-full h-full scale-0 origin-center transition-all duration-300',
          { 'scale-100': !disabled }
        )}
        viewBox="0 0 16 16"
      >
        <path
          d="M11.5858 4.35755C11.8399 4.15049 12.2164 4.13167 12.4799 4.34814C12.7811 4.60226 12.8187 5.04461 12.5552 5.34579L7.5858 11.3128C7.50109 11.4164 7.40698 11.5105 7.29404 11.5858C6.64462 12.0187 5.76933 11.8399 5.33639 11.1905L3.37874 8.25402C3.16227 7.93402 3.25639 7.49167 3.57639 7.2752C3.82109 7.1152 4.13168 7.12461 4.35757 7.2752L6.41874 8.63991L11.5764 4.34814L11.5858 4.35755Z"
          fill="white"
        />
      </svg>
    </div>
    <div>
      <span className="block text-sm text-black">{name}</span>
      <span className="block mt-1 text-sm text-neutral-700">{id} annotations</span>
    </div>
  </li>
);

export default Annotation;
